import { cn } from "@/lib/utils";
import { ScrollArea } from "./ui/scroll-area";
import type { ScrollAreaProps } from "@radix-ui/react-scroll-area";

type StyledDivProps = JSX.IntrinsicElements["div"];

export type ModalTabInfo = {
    title: string;
    icon: JSX.Element;
    className?: string;
}

export function ModalContent({ children, className, ...props }: StyledDivProps & ScrollAreaProps) {
    return (
        <div className={cn('flex flex-col md:flex-row md:px-4 h-full', className)} {...props}>
            {children}
        </div>
    );
}

export function ModalTabsList({ children, className, ...props }: StyledDivProps & ScrollAreaProps) {
    return (
        <div className={cn('flex flex-row md:flex-col gap-1 md:min-w-[186px] rounded-[11px] border border-fc-stroke bg-fc-well md:border-0 md:bg-transparent p-1 md:p-0 mx-2 md:mx-0 overflow-x-auto', className)} {...props}>
            {children}
        </div>
    );
}

export function ModalTabWrapper({ children, className, ...props }: StyledDivProps & ScrollAreaProps) {
    return (
        <ScrollArea className={cn('min-h-[16rem] w-full md:max-h-[50vh] px-2 md:px-4 max-md:pt-3', className)} {...props}>
            {children}
        </ScrollArea>
    );
}

export function ModalTabInner({ children, className, ...props }: StyledDivProps) {
    return (
        <div className={cn('px-1 pb-1 animate-fc-tab-in', className)} {...props}>
            {children}
        </div>
    );
}

export function ModalTabMessage({ children, className, ...props }: StyledDivProps) {
    return (
        <div className={cn('min-h-[16rem] p-2 md:p-4 flex items-center justify-center text-[15px] text-fc-txt3', className)} {...props}>
            {children}
        </div>
    )
}
